import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import { createVeteranInfoConflictField } from '../components/ConflictPageField';

const ConfirmVeteranInfoField = createVeteranInfoConflictField(
  'No conflicts were found between your uploaded documents and the information you entered.',
);

export default {
  uiSchema: {
    ...titleUI(
      'Confirm Veteran information',
      'The information you entered is different than what we detected in your documents. Review and confirm which information is correct.',
    ),
    veteranInfoConflictData: {
      'ui:field': ConfirmVeteranInfoField,
    },
  },
  schema: {
    type: 'object',
    properties: {
      veteranInfoConflictData: {
        type: 'object',
        properties: {},
      },
    },
  },
};
